module.exports = "/images/Go-Karts.svg?58304a769afd36e8ab9026523434d8e3";